<script setup lang="ts">
const {
  real,
  planned,
  cancelled,
  inline = false
} = defineProps<{
  real: string
  planned?: string
  cancelled?: boolean
  inline?: boolean
}>()
</script>

<template>
  <span>
    <div :class="inline ? 'd-inline' : ''">
      <del v-if="cancelled === true">{{ real }}</del>
      <span v-else>
        {{ real }}
      </span>
    </div>
    <div v-if="planned && real !== planned" :class="inline ? 'd-inline ps-2' : ''">
      <del class="text-body-secondary">{{ planned }}</del>
    </div>
  </span>
</template>
